import theme from '@corabank/design-tokens/build/tokens/colors.json'
import { Check } from '@corabank/icons'

import * as Styled from './styles'

export const DOCS_FORM = {
  SUCCESS_MESSAGE: {
    ATTACHED_DOC: (
      <Styled.DocsFormFeedbackInfo>
        <Check color={theme.graysWhite} /> O documento foi anexado com sucesso!
      </Styled.DocsFormFeedbackInfo>
    ),
    ATTACHED_DOC_METRIC:
      'up_documento: viu_ alerta_doc_anexado_sucesso [tela_up_documentos]',
    REMOVED_DOC: (
      <Styled.DocsFormFeedbackInfo>
        <Check color={theme.graysWhite} />O documento foi excluído
      </Styled.DocsFormFeedbackInfo>
    ),
    REMOVED_DOC_METRIC:
      'up_documento: viu_alerta_doc_excluido_sucesso [tela_up_documentos]',
  },
}
